export default __webpack_public_path__ + "static/media/camera.9071df70.svg";